var audio_rtlignore_default = {
  "fontElementMap": "_5nXIi",
  "container": "GSMSc",
  "customPlayer": "gdy9k",
  "slim": "Mq02s",
  "playPauseButton": "W3TSn",
  "coverImage": "MnIMD",
  "trackDetailsContainer": "h0EHZ",
  "controlsContainer": "oMVVS",
  "controlsGroup": "wYaFn",
  "sliderContainer": "Qtriv",
  "audioDuration": "BnDhj",
  "isLoading": "diYlK",
  "audioDetails": "Yzd1I",
  "authorName": "bG62N",
  "title": "GOfs3",
  "dropdownMenuWrapper": "Vj2MO",
  "dropdownSelectedButton": "vNZRT",
  "dropdownContent": "TjI-W",
  "dropdownContentWithIcon": "D-j0E",
  "audioLoader": "WExdo"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
